import { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { Footer, Wrapper } from 'components'
import { useNavigate } from 'react-router-dom'
import { Button, Card, Input, toast } from 'keep-react'
import { RouteNamesNonAuth } from 'routes/enum'
import { authService } from 'api/services/auth'

const recoveryValidationSchema = Yup.object().shape({
  email: Yup.string().email().required('Email é obrigatório'),
})

export const RequestNewPassword = () => {
  const [isRecovering, setIsRecovering] = useState<boolean>(false)
  const navigate = useNavigate()

  const recoverFormik = useFormik({
    initialValues: { email: '' },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: recoveryValidationSchema,
    onSubmit: async values => {
      setIsRecovering(true)
      try {
        await authService.resetPasswordSendEmailGenerateToken({
          email: values.email,
        })
        toast.success(
          'Se o email existir na nossa base de dados, irá receber um email com instruções para o reset da password.',
        )
        setIsRecovering(false)
      } catch (err) {
        toast.error('Erro a fazer o reset da password.')
      } finally {
        setIsRecovering(false)
      }
    },
  })

  return (
    <div
      className="w-screen h-screen bg-cover bg-no-repeat bg-center flex items-center"
      style={{
        backgroundImage: `url(images/dark_broker.jpg)`,
      }}
    >
      <Wrapper>
        <div className="flex flex-col items-center m-auto gap-x-4 gap-y-12 max-w-[700px] h-full">
          <h1 className="text-white uppercase font-semibold text-2xl text-center tracking-wider">
            Seguros à velocidade de um foguetão
          </h1>
          <div className="grid grid-cols-2 gap-12 items-center w-full">
            <div className="flex flex-col gap-6">
              <Card className="w-full bg-white/70 p-4 rounded-xl max-w-none">
                <h2 className="font-light text-heading-6 text-primary-400 pb-4 uppercase">
                  Recuperar password
                </h2>
                <form
                  autoComplete="false"
                  onSubmit={e => {
                    e.preventDefault()
                    recoverFormik.submitForm()
                  }}
                >
                  <div className="space-y-5">
                    <Input
                      name="email"
                      placeholder="Email"
                      type="email"
                      onChange={recoverFormik.handleChange}
                    />
                    <div className="flex justify-end">
                      <Button
                        type="button"
                        color="primary"
                        variant="link"
                        className="underline text-body-5 p-0 cursor-pointer"
                        onClick={() => {
                          navigate(RouteNamesNonAuth.LOGIN)
                        }}
                      >
                        Voltar ao login
                      </Button>
                    </div>
                    <Button
                      className="w-full"
                      type="submit"
                      disabled={isRecovering}
                    >
                      Submeter
                    </Button>
                  </div>
                </form>
              </Card>
            </div>

            <div className="flex flex-col gap-4 items-center justify-center">
              <img
                src="/images/rocket.svg"
                alt="Innovarisk"
                className="max-w-[220px] animate-slideInFade"
              />
              <h2 className="text-white font-roboto mb-[50px] mt-[50px] text-lg text-center">
                A solução que permite de forma simples e fácil aceder aos
                produtos especializados para nichos de mercado.{' '}
              </h2>
            </div>
          </div>
        </div>
      </Wrapper>
      <Footer />
    </div>
  )
}
